import actionsFooterUrl from './actions-footer.html';
export default {
  controllerAs: 'ctrl',
  bindings: {
    save: '&',
    cancel: '&',
  },
  require: {
    form: '^form',
  },
  transclude: true,
  templateUrl: actionsFooterUrl,
};
